// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import MasterService from '@services/masters/driving-license-master'

export const getAllDrivingLicenseDriveType = createAsyncThunk('drive-types/getAllDrivingLicenseDriveType', async (params, { rejectWithValue }) => {
  try {
    const response = await MasterService.getAllDrivingLicenseDriveTypes(params)
    // console.log('res', response)
    return { params, data: response.data, totalPages: response.meta.itemCount }
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const getDrivingLicenseDriveType = createAsyncThunk('drive-types/getDrivingLicenseDriveType', async (id, { rejectWithValue }) => {
  try {
    const response = await MasterService.getDrivingLicenseDriveType(id)
    // console.log('reason', response)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const addDrivingLicenseDriveType = createAsyncThunk('drive-types/addDrivingLicenseDriveType', async (type, { rejectWithValue, dispatch, getState }) => {
  try {
    const response = await MasterService.addDrivingLicenseDriveType(type)
    dispatch(getAllDrivingLicenseDriveType(getState()?.drivingLicenseDriveTypes.params))
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const updateDrivingLicenseDriveType = createAsyncThunk('drive-types/updateDrivingLicenseDriveType', async (type, { rejectWithValue, dispatch, getState }) => {
  try {
    const response = await MasterService.updateDrivingLicenseDriveType(type)
    dispatch(getAllDrivingLicenseDriveType(getState()?.drivingLicenseDriveTypes.params))
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const deleteDrivingLicenseDriveType = createAsyncThunk('drive-types/deleteDrivingLicenseDriveType', async (id, { dispatch, getState }) => {
  await MasterService.deleteDrivingLicenseDriveType(id)
  await dispatch(getAllDrivingLicenseDriveType(getState()?.drivingLicenseDriveTypes.params))
  return id
})

const DrivingLicenseDriveType = createSlice({
  name: 'driving_license_type',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedDrivingLicenseDriveType: null
  },
  reducers: {},

  extraReducers(builder) {
    builder
      .addCase(getAllDrivingLicenseDriveType.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.selectedDrivingLicenseDriveType = null
      })
      .addCase(getDrivingLicenseDriveType.fulfilled, (state, action) => {
        state.selectedDrivingLicenseDriveType = action.payload
      })
      .addCase(updateDrivingLicenseDriveType.fulfilled, (state, action) => {
        if (!action.payload?.id) {
          console.log('Update could not complete')
          console.log(action.payload)
          return
        }
        const { id } = action.payload
        const drivingLicenseDriveType = state.data.filter((drivingLicenseDriveType) => drivingLicenseDriveType.id !== id)
        state.data = [...drivingLicenseDriveType, action.payload]
      })
  }
})

// export const getAllOfficeLocation = (state) => state.officeLocations.office_location
// export const selectOfficeLocationById = (state, id) => state.officeLocations.data.find((office_location) => office_location.id === id)

export default DrivingLicenseDriveType.reducer
